import { render, staticRenderFns } from "./AudioPlayerControls.vue?vue&type=template&id=5f6ab19c&scoped=true"
import script from "./AudioPlayerControls.vue?vue&type=script&lang=js"
export * from "./AudioPlayerControls.vue?vue&type=script&lang=js"
import style0 from "./AudioPlayerControls.vue?vue&type=style&index=0&id=5f6ab19c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6ab19c",
  null
  
)

export default component.exports